import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import * as invoiceDateActions from '../../actions/invoiceDateActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getPermissionByName, hasReportPermission } from '../../util/customMethods';
import { 
  faDashboard, 
  faPlusCircle,
  faMap, 
  faSearch, 
  faFileAlt, 
  faCalendarAlt, 
  faSignOutAlt, 
  faChartBar,
  faChevronRight 
} from '@fortawesome/free-solid-svg-icons';

// Report configuration - matches AVAILABLE_REPORTS in admin section
const AVAILABLE_REPORTS = [
  { 
    type: 'ARS_USAGE', 
    label: 'ARS Usage Report',
    route: '/ars-usage-report'
  },
  { 
    type: 'RESPONSE', 
    label: 'Response Report',
    route: '/response-report'
  },
  { 
    type: 'RESPONSE_SPD', 
    label: 'Response Report',  // Same label - vendor only sees one
    route: '/response-report-spd'
  }
  // Add more reports here as needed
];

class LeftMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      towSheetsCollapsed: true,
      reportsCollapsed: true,
      expandedYear: null,
    };
  }

  toggleReports = () => {
    this.setState(prevState => ({
      reportsCollapsed: !prevState.reportsCollapsed
    }));
  }

  componentWillMount = () => {
    this.props.getInvoiceMonthYears(this.props.authInfo.userId);
  }

  toggleTowSheets = () => {
    this.setState(prevState => ({
      towSheetsCollapsed: !prevState.towSheetsCollapsed
    }));
  }

  toggleYear = (year) => {
    this.setState(prevState => ({
      expandedYear: prevState.expandedYear === year ? null : year
    }));
  }

  getCollapseStyle = (isExpanded) => {
    return {
      display: isExpanded ? 'block' : 'none'
    };
  }

  getNestedMenuStyle = {
    paddingLeft: '20px'
  }

  getChevronStyle = (isExpanded) => ({
    marginLeft: 'auto',
    transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
    transition: 'transform 0.2s ease'
  })

  // NEW: Get enabled reports based on permissions
  getEnabledReports = () => {
    return AVAILABLE_REPORTS.filter(report => 
      hasReportPermission(report.type)
    );
  }

  render() {
    const { invoiceMonthYears, invoiceSelectedDate, authInfo } = this.props;
    const { towSheetsCollapsed, expandedYear, reportsCollapsed } = this.state;
    
    // NEW: Get enabled reports dynamically
    const enabledReports = this.getEnabledReports();
    const hasAnyReportPermission = enabledReports.length > 0;

    const asideStyle = {
      top: '20px', // Height of the header
    
    };

    const mainLinkStyle = {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      padding: '15px 15px',
      color: '#a3a3a3',
      textDecoration: 'none'
    };

    const nestedLinkStyle = {
      ...mainLinkStyle,
      paddingLeft: '35px'
    };

    const monthLinkStyle = {
      ...mainLinkStyle,
      paddingLeft: '55px'
    };

    const navStyle = {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    };

    const ulStyle = {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      flex: 1
    };

    const footerStyle = {
      marginTop: 'auto',
      borderTop: '1px solid rgba(255,255,255,0.1)'
    };

    return (
      <aside className="aside" style={asideStyle}>
        <nav className="sidebar" style={navStyle}>
        <ul className="nav" style={ulStyle}>
            {getPermissionByName('dashboard') && (
              <li>
                <Link to="/dashboard" style={mainLinkStyle}>
                  <FontAwesomeIcon icon={faDashboard} style={{ marginRight: '10px' }}/>
                  <span className="item-text">Dashboard</span>
                </Link>
              </li>
            )}
            {getPermissionByName('dashboard') && (
              <li>
                <Link to="/newRequest" style={mainLinkStyle}>
                  <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: '10px' }}/>
                  <span className="item-text">New Request</span>
                </Link>
              </li>
            )}
            {getPermissionByName('map') && (
              <li>
                <Link to="/map" style={mainLinkStyle}>
                  <FontAwesomeIcon icon={faMap} style={{ marginRight: '10px' }}/>
                  <span className="item-text">Map</span>
                </Link>
              </li>
            )}
            {getPermissionByName('search') && (
              <li>
                <Link to="/search" style={mainLinkStyle}>
                  <FontAwesomeIcon icon={faSearch} style={{ marginRight: '10px' }}/>
                  <span className="item-text">Search</span>
                </Link>
              </li>
            )}
            {/* MODIFIED: Reports section now builds dynamically based on report permissions */}
            {getPermissionByName('reports') && hasAnyReportPermission && (
              <li>
                <a href="#reports" onClick={this.toggleReports} style={mainLinkStyle}>
                  <FontAwesomeIcon icon={faChartBar} style={{ marginRight: '10px' }}/>
                  <span className="item-text">Reports</span>
                  <FontAwesomeIcon 
                    icon={faChevronRight} 
                    style={this.getChevronStyle(!reportsCollapsed)} 
                  />
                </a>
                {/* NEW: Dynamic report menu items */}
                <ul className="nav" style={this.getCollapseStyle(!reportsCollapsed)}>
                  {enabledReports.map(report => (
                    <li key={report.type}>
                      <Link to={report.route} style={nestedLinkStyle}>
                        <FontAwesomeIcon icon={faChartBar} style={{ marginRight: '10px' }} />
                        <span className="item-text">{report.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            )}
            {getPermissionByName('towSheets') && (
              <li>
                <a href="#towSheets" onClick={this.toggleTowSheets} style={mainLinkStyle}>
                  <FontAwesomeIcon style={{ marginRight: '10px' }} icon={faFileAlt} />
                  <span className="item-text">Tow Sheets</span>
                  <FontAwesomeIcon 
                    icon={faChevronRight} 
                    style={this.getChevronStyle(!towSheetsCollapsed)} 
                  />
                </a>
                <ul className="nav" style={this.getCollapseStyle(!towSheetsCollapsed)}>
                  {Object.keys(invoiceMonthYears || {}).sort((a, b) => b - a).map(year => (
                    <React.Fragment key={year}>
                      <li className={expandedYear === year ? 'active' : null}>
                        <a 
                          href="#year" 
                          onClick={(e) => {
                            e.preventDefault();
                            this.toggleYear(year);
                          }}
                          style={nestedLinkStyle}
                        >
                          <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: '10px' }}/>
                          <span className="item-text">{year}</span>
                          <FontAwesomeIcon 
                            icon={faChevronRight} 
                            style={this.getChevronStyle(expandedYear === year)} 
                          />
                        </a>
                      </li>
                      <div style={this.getCollapseStyle(expandedYear === year)}>
                        {(invoiceMonthYears[year] || []).map((month, index) => (
                          <li 
                            key={index} 
                            className={invoiceSelectedDate && invoiceSelectedDate.selectedMonth === parseInt(month.monthNo) ? 'active' : null}
                          >
                            <a 
                              href="#" 
                              onClick={(e) => {
                                e.preventDefault();
                                this.props.setInvoiceSelectedDate(parseInt(year), parseInt(month.monthNo), 0);
                                this.props.getInvoiceList(authInfo.userId, parseInt(year), parseInt(month.monthNo));
                                this.props.history.push('/home');
                              }}
                              style={monthLinkStyle}
                            >
                              <span className="item-text">{month.month}</span>
                            </a>
                          </li>
                        ))}
                      </div>
                    </React.Fragment>
                  ))}
                </ul>
              </li>
            )}
            <li className="nav-footer">
              <div className="btn-group text-center">
                <button 
                  type="button" 
                  data-toggle="tooltip" 
                  data-title="Logout" 
                  className="btn btn-link" 
                  onClick={this.logout}
                  style={mainLinkStyle}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '10px' }} />
                  <span>Logout</span>
                </button>
              </div>
            </li>
          </ul>
        </nav>
      </aside>
    );
  }
}

const mapStateToProps = (state) => ({
  invoiceSelectedDate: state.invoiceSelectedDate,
  authInfo: state.authInfo,
  invoiceMonthYears: state.invoiceMonthYears
});

const mapDispatchToProps = (dispatch) => ({
  setInvoiceSelectedDate: (_year, _month, _date) => {
    const searchInput = document.getElementById('txtSearch');
    const searchPanel = document.getElementById('search-pan');
    if (searchInput) searchInput.value = '';
    if (searchPanel) searchPanel.classList.remove('open');
    dispatch(invoiceDateActions.setInvoiceSelectedDate(_year, _month, _date));
  },
  getInvoiceList: (user, _year, _month) => {
    const searchInput = document.getElementById('txtSearch');
    const searchPanel = document.getElementById('search-pan');
    if (searchInput) searchInput.value = '';
    if (searchPanel) searchPanel.classList.remove('open');
    dispatch(invoiceDateActions.getInvoiceList(user, _year, _month));
  },
  getInvoiceMonthYears: (user) => {
    dispatch(invoiceDateActions.getInvoiceMonthYears(user));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeftMenu));
